const typography = {
  fontFamily: "inherit",
  h1: {
    fontWeight: 400,
    fontSize: "32px",
    lineHeight: "40px",
  },
  h2: {
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "32px",
  },
  h3: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  h4: {
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  h5: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
  },
  h6: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18px",
  },
  h7: {
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
  },
  h8: {
    fontSize: "10px",
    fontWeight: 400,
    lineHeight: "12px",
  },
};

export default typography;
